export default __webpack_public_path__ + "static/media/Facebook.2b8a6512.svg";